export default {
  getLastEvidenceByKindAndCrm({ crm, evidencekind, evidencetype }) {
    return axios.post(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/last-evidence-by-kind-and-crm',
      {
        crm,
        evidencekind,
        evidencetype,
      },
    );
  },
  search({ search, type, evidencetype }) {
    return axios.post(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/search',
      {
        search,
        type,
        evidencetype,
      },
    );
  },
  getExchangeRatesDiff({ evidenceId, exchangeItems }) {
    return axios.post(
      import.meta.env.VITE_SITE_URL + `/bookkeepings/evidences/ryczalts/get-exchange-rates-differences/${ evidenceId }`,
      {
        exchangeItems,
      },
    );
  },
  createFromExchangeRates(data) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/evidences/create-from-exchange-rates`, data);
  },
  createFromOcrFile(id) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/evidences/create-from-ocr-file/${ id }`);
  },
  createFromInvoice(id) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/evidences/create-from-invoice/${ id }`);
  },
  settle(payload) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/evidences/settle`, payload);
  },
  RYCZALT: {
    index({ queryUrl }) {
      return axios.get(
        import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences' + queryUrl,
        {
          params: {},
        },
      );
    },
    store(evidence) {
      return axios.post(import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/ryczalts', { evidence });
    },
    show(id) {
      return axios.get(
        import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/ryczalts/' + id,
        {
          params: {},
        },
      );
    },
    update(evidence) {
      return axios.put(
        import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/ryczalts/' + evidence.id,
        { evidence },
      );
    },
    destroy(id) {
      return axios.delete(
        import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/ryczalts/' + id,
      );
    },

    calculate(evidence, params = {}) {
      return axios.post(
        import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/ryczalts/calculate',
        { evidence },
        params,
      );
    },
  },

  KPIR: {
    fetchEvidences(url, sortType = 'desc', config = {}) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences' + url,
        {
          ...config,
          headers: { Sort: sortType },
        },
      );
    },
    fetchSales(url, sortType = 'desc', config = {}) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/vat-sales' + url,
        {
          ...config,
          headers: { Sort: sortType },
        },
      );
    },
    fetchPurchases(url, sortType = 'desc', config = {}) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/vat-purchases' + url,
        {
          ...config,
          headers: { Sort: sortType },
        },
      );
    },
  },

  PRINT: {
    yearTaxStatementSummary({ year, type, evidencetype }) {
      return axios.post(
        import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/year-tax-statement-summary',
        {
          year,
          type,
          evidencetype,
        },
      );
    },
    kPiRYearSummaryPrint({ year, type, evidencetype }) {
      return axios.post(
        import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/kpir-year-summary-print',
        {
          year,
          type,
          evidencetype,
        },
      );
    },
    kPiRPerMonthPrint(data) {
      return axios.post(
        import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/kpir-per-month-print',
        data,
      );
    },
    ryczaltPerMonthPrint(data) {
      return axios.post(
        import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/ryczalts/ryczalt-per-month-print',
        data,
      );
    },
    ryczaltYearSummaryPrint({ year, type, evidencetype }) {
      return axios.post(
        import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/ryczalt-year-summary-print',
        {
          year,
          type,
          evidencetype,
        },
      );
    },
  },
  taxes({
          year,
          month,
          evidencetype,
          pitsettlementsperiodtype,
        } = {}) {
    return axios.get(
      import.meta.env.VITE_SITE_URL + '/bookkeepings/evidences/taxes',
      {
        params: {
          year,
          month,
          evidencetype,
          pitsettlementsperiodtype,
        },
      },
    );
  },
  getPreviousCounterByDate({ counter, month, year }) {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/bookkeepings/evidences/previous/counter/${ counter }/month/${ month }/year/${ year }`);
  },
};
